export class LoginDataRef {
  loginUsername: string = "";
  loginPassword: string = "";
  loginAuthCode: string = "";
}
